import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup, MatTab, MatTabHeader } from '@angular/material/tabs';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DropdownItem, NoteItem } from 'projects/admin/src/app/models/commonModel';
import { HistoryItem, PaymentTab, ApplicationTypes, InternalTabTypes, LicenseTab, QualificationTab, PhysicalAddressTab, MailingAddressTab, ConfirmationTab, SignatureTab } from 'projects/admin/src/app/models/exemptionFilling';
import { ExemptionFilingRequestService } from 'projects/admin/src/app/services/exemptionFilingRequest';
import { LoginService } from 'projects/admin/src/app/services/login.service';
import { WarningModalComponent } from 'projects/admin/src/app/shared/warning-modal/warning-modal.component';
import { YesNoModalComponent } from 'projects/admin/src/app/shared/yes-no-modal/yes-no-modal.component';
import { forkJoin } from 'rxjs';
import { ExternalCommonService } from '../shared/services/external.common.service';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit, AfterViewInit {
  form!: FormGroup;
  QualificationTab!: FormGroup;
  PhysicalAddressTab!: FormGroup;
  MailingAddressTab!: FormGroup;
  PysicalMailingSame!: FormControl;
  requestStatusTypeId!: FormControl;
  externalStatusTypeId!: FormControl;
  LicenseTab!: FormGroup;
  SignatureTab!: FormGroup;
  ConfirmationTab!: FormGroup;
  PaymentTab!: FormGroup;
  userName: string = '';
  selectedIndex: number = 0;
  requestId: number = 0;
  data: any;
  summaryData: any;
  historyData: HistoryItem[] = [];
  isDynamicValidationAdded = false;
  qualificationTypes: DropdownItem[] = [];
  countyTypes: DropdownItem[] = [];
  countryTypes: DropdownItem[] = [];
  stateTypes: DropdownItem[] = [];
  cityTypes: DropdownItem[] = [];
  allCites: DropdownItem[] = [];
  paymentTypes:  DropdownItem[] = [];
  notes: NoteItem[] = [];
  requestStatusTypes: DropdownItem[] = [];
  externalStatusTypes: DropdownItem[] = [];
  requestTypes: DropdownItem[] = [];
  requestTypeName = '';
  user: any;
  editUserRoles = ['Administrator', 'Supervisor', 'Program Coordinator'];
  readOnlyRequstStatusTypeCode = ['ACCEPTED', 'REJECTED'];
  approvedRequstStatusTypeCode = 'ACCEPTED';
  fisPaymentTypeCode = 'FIS';
  fisPaymentData: PaymentTab | undefined;
  qualTypeForEntityControl = [
    'OFFICERCORP',
    'MEMBERLLC',
    'FAMILYOWNER',
    'PARTNERLLP',
  ];
  qualificationTabApplies = [
    ApplicationTypes.InitialApplication,
    ApplicationTypes.SubsequentApplication,
  ];
  verificationTabApplies = [
    ApplicationTypes.RenewalApplication,
    ApplicationTypes.SubsequentRenewalApplication,
    ApplicationTypes.ReinstatementsApplication,
    ApplicationTypes.SubsequentReinstatementApplication,
    ApplicationTypes.VoluntaryRevocation,
    ApplicationTypes.RequestaCopy,
    ApplicationTypes.ChangeofAddress,
    ApplicationTypes.Corrections,
  ];
  phyAddressTabApplies = [
    ApplicationTypes.InitialApplication,
    ApplicationTypes.RenewalApplication,
    ApplicationTypes.SubsequentApplication,
    ApplicationTypes.SubsequentRenewalApplication,
    ApplicationTypes.Corrections,
  ];
  mailAddressTabApplies = [
    ApplicationTypes.InitialApplication,
    ApplicationTypes.RenewalApplication,
    ApplicationTypes.SubsequentApplication,
    ApplicationTypes.SubsequentRenewalApplication,
    ApplicationTypes.Corrections,
  ];
  licenseTabApplies = [
    ApplicationTypes.InitialApplication,
    ApplicationTypes.RenewalApplication,
    ApplicationTypes.SubsequentApplication,
    ApplicationTypes.SubsequentRenewalApplication,
    ApplicationTypes.Corrections,
  ];
  confirmTabApplies = [
    ApplicationTypes.InitialApplication,
    ApplicationTypes.RenewalApplication,
    ApplicationTypes.SubsequentApplication,
    ApplicationTypes.SubsequentRenewalApplication,
  ];
  paymentTabApplies = [
    ApplicationTypes.InitialApplication,
    ApplicationTypes.RenewalApplication,
    ApplicationTypes.SubsequentApplication,
    ApplicationTypes.SubsequentRenewalApplication,
    ApplicationTypes.ReinstatementsApplication,
    ApplicationTypes.SubsequentReinstatementApplication,
    ApplicationTypes.VoluntaryRevocation,
    ApplicationTypes.RequestaCopy,
    ApplicationTypes.ChangeofAddress,
    ApplicationTypes.Corrections,
  ];
  signatureTabApplies = [
    ApplicationTypes.InitialApplication,
    ApplicationTypes.RenewalApplication,
    ApplicationTypes.SubsequentApplication,
    ApplicationTypes.SubsequentRenewalApplication,
    ApplicationTypes.ReinstatementsApplication,
    ApplicationTypes.SubsequentReinstatementApplication,
    ApplicationTypes.VoluntaryRevocation,
    ApplicationTypes.RequestaCopy,
    ApplicationTypes.ChangeofAddress,
    ApplicationTypes.Corrections,
  ];
  selectedTab: InternalTabTypes = InternalTabTypes.QualificationTab;
  @ViewChild('tabs') tabs!: MatTabGroup;
  canSave = false;
  canAssign = false;
  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private router: ActivatedRoute,
    private exemptionFilingRequestService: ExemptionFilingRequestService,
    private commonService: ExternalCommonService,
    private loginService: LoginService,
    private toastr: ToastrService,
    private routerService: Router,
    private sanitizer: DomSanitizer
  ) {
    // this.user = this.loginService.getUser();
  }

  private createForm() {
    this.requestStatusTypeId = new FormControl();
    this.externalStatusTypeId = new FormControl();
    this.CreateForms();

    this.form = this.fb.group({
      requestStatusTypeId: this.requestStatusTypeId,
      externalStatusTypeId: this.externalStatusTypeId,
      QualificationTab: this.QualificationTab,
      PhysicalAddressTab: this.PhysicalAddressTab,
      MailingAddressTab: this.MailingAddressTab,
      LicenseTab: this.LicenseTab,
      ConfirmationTab: this.ConfirmationTab,
      SignatureTab: this.SignatureTab,
      PaymentTab: this.PaymentTab,
    });
  }

  payonline(){
    window.location.href = 'https://localhost:7189/1/FISpayment';
  }
  
  private AddQualitficationTabDynamicValidators() {
    if (
      this.qualificationTabApplies.includes(
        this.data?.exemptionRequestType?.code
      )
    ) {
      this.QualificationTab.controls[
        'qualificationType'
      ].valueChanges.subscribe((value) => {
        if (value >= 0) {
          let qual = this.qualificationTypes.filter((x: any) => x?.id == value);
          if (
            qual.length > 0 &&
            this.qualTypeForEntityControl.includes(qual[0].code)
          ) {
            this.addValidators(
              'QualificationTab',
              'entityControlNumber',
              Validators.required
            );
          } else {
            this.clearValidators('QualificationTab', 'entityControlNumber');
          }
        }
      });
    }
  }

  private AddLicenseTabDynamicValidators() {
    var nrCounty = this.getNotRequiredCounty().id;
    this.LicenseTab.controls['county'].valueChanges.subscribe(() => {
      this.filterCitiesforCounty(this.LicenseTab.controls['county'].value);
    });
    this.addCondtionalRequiredValidators(
      'LicenseTab',
      'county',
      ['countyLicenseNumber', 'countyLicenseExpirationDate'],
      nrCounty
    );

    this.addCondtionalRequiredValidators(
      'LicenseTab',
      'hasActiveStateLicense',
      ['stateLicenseNumber', 'stateLicenseExpirationDate'],
      false
    );

    var nrCty = this.getNotRequiredCity().id;
    this.addCondtionalRequiredValidators(
      'LicenseTab',
      'city',
      ['cityLicenseNumber', 'cityLicenseExpirationDate'],
      nrCty
    );
  }

  private addCondtionalRequiredValidators(
    tabName: string,
    fieldName: string,
    fields: string[],
    expectedvalue: any
  ) {
    console.log(`tab ${tabName} fname ${fieldName} ${expectedvalue}`);
    (this.form.controls[tabName] as FormGroup)?.controls[
      fieldName
    ].valueChanges.subscribe((value) => {
      console.log(
        `tab ${tabName} fname ${fieldName} ${expectedvalue} value ${value}`
      );

      if (value && value != expectedvalue) {
        fields.forEach((fname) => {
          this.addValidators(tabName, fname, Validators.required);
        });
      } else {
        fields.forEach((fname) => {
          this.clearValidators(tabName, fname);
        });
      }
    });
  }

  addValidators(tabName: string, fieldName: string, valdtrs: ValidatorFn) {
    let ctrl = (this.form.controls[tabName] as FormGroup)?.controls[
      fieldName
    ] as AbstractControl;
    ctrl.addValidators(valdtrs);
    ctrl.updateValueAndValidity();
  }

  clearValidators(tabName: string, fieldName: string) {
    let ctrl = (this.form.controls[tabName] as FormGroup)?.controls[fieldName];
    ctrl.clearValidators();
    ctrl.updateValueAndValidity();
  }

  private filterCitiesforCounty(value: any) {
    console.log(value);
    if (value != undefined || value != '') {
      this.cityTypes = this.allCites.filter((x: any) => x?.county.id == value);

      if (!this.cityTypes.some((x: any) => x?.name == 'Not Required')) {
        let notRequiredCity = this.allCites.filter(
          (x: any) => x?.name == 'Not Required'
        );
        if (notRequiredCity?.length > 0)
          this.cityTypes.unshift(notRequiredCity[0]);
      }
    }
  }

  getNotRequiredCounty() {
    let county = this.countyTypes.filter((x: any) => x?.name == 'Not Required');
    return county[0];
  }

  getNotRequiredCity() {
    let city = this.allCites.filter((x: any) => x?.name == 'Not Required');
    console.log(this.allCites);
    console.log(city);
    return city[0];
  }

  ngOnInit(): void {
    // this.requestId = +atob(this.router.snapshot.params.id);
    this.createForm();
    
  }

  ngAfterViewInit(): void {
  //  this.loadData();
    setTimeout(() => {
      console.log(this.tabs);
      this.tabs._handleClick = this.interceptTabChange.bind(this);
    });
  }



  private loadData() {
    this.loadTypesData();
    this.exemptionFilingRequestService
      .getNotes(this.requestId)
      .subscribe((res) => {
        console.log(res);
        this.notes = res;
      });
      this.commonService.getPaymentTypes().subscribe((res) => {
        this.paymentTypes = res;
        this.exemptionFilingRequestService.getPayments(this.requestId)
        .subscribe((payments: PaymentTab[]) => {
          const fisPaymentId = this.paymentTypes.find(x => x.code == this.fisPaymentTypeCode)?.id;
          this.fisPaymentData = payments.find(x => x.paymentTypeId ==  fisPaymentId);
          this.data.PaymentTab = payments.find(x => x.paymentTypeId !=  fisPaymentId);
          console.log(this.fisPaymentData);
          console.log(this.data.PaymentTab);
        });
      });
    forkJoin({
      exemptionData:
        this.exemptionFilingRequestService.getExemptionFilingRequestDetail(
          this.requestId
        ),
      payTypes: this.commonService.getPaymentTypes(),
      summary: this.exemptionFilingRequestService.getSummary(this.requestId),
      history: this.exemptionFilingRequestService.getHistory(this.requestId),
      reqTypes: this.commonService.getRequestTypes(),
      countyty: this.commonService.getCountyTypes(),
      cty: this.commonService.getCityTypes(),
      stats: this.commonService.getStateTypes(),
      payments: this.exemptionFilingRequestService.getPayments(this.requestId)
    }).subscribe(
      ({ exemptionData, reqTypes, cty, countyty, stats, summary, history, payTypes, payments }) => {
        console.log(history);
        (this.summaryData = summary), (this.requestTypes = reqTypes);
        this.paymentTypes = payTypes;
        this.countyTypes = countyty;
        this.allCites = cty;
        this.stateTypes = stats;
        const fisPaymentId = this.paymentTypes.find(x => x.code == this.fisPaymentTypeCode)?.id;
        this.fisPaymentData = payments.find((fx: { paymentTypeId: number | undefined; }) => fx.paymentTypeId ==  fisPaymentId);
        exemptionData.PaymentTab = payments.find((px: { paymentTypeId: number | undefined; }) => px.paymentTypeId !=  fisPaymentId);
        this.populateFormData(exemptionData);
        this.historyData = history;
        
      }
    );
  }

  private refreshData() {
    forkJoin({
      exemptionData:
        this.exemptionFilingRequestService.getExemptionFilingRequestDetail(
          this.requestId
        ),
      history: this.exemptionFilingRequestService.getHistory(this.requestId),
      payments: this.exemptionFilingRequestService.getPayments(this.requestId)
    }).subscribe(
      ({ exemptionData, history, payments }) => {
        console.log(history);
        const fisPaymentId = this.paymentTypes.find(x => x.code == this.fisPaymentTypeCode)?.id;
        this.fisPaymentData = payments.find((fx: { paymentTypeId: number | undefined; }) => fx.paymentTypeId ==  fisPaymentId);
        exemptionData.PaymentTab = payments.find((px: { paymentTypeId: number | undefined; }) => px.paymentTypeId !=  fisPaymentId);
        this.populateFormData(exemptionData);
        this.historyData = history;
        
      }
    );
  }

  private loadTypesData() {
    this.commonService.getQualificationTypes().subscribe((res) => {
      this.qualificationTypes = res;
    });
    this.commonService.getCountryTypes().subscribe((res) => {
      this.countryTypes = res;
    });

    this.commonService.getRequestStatusTypes().subscribe((res) => {
      this.requestStatusTypes = res;
    });
    this.commonService.getExternalStatusTypes().subscribe((res: DropdownItem[]) => {
      this.externalStatusTypes = res;
    });
  }

  private populateFormData(res: any) {
    setTimeout(() => {
      this.data = res;
      this.form.patchValue(this.data);
      this.QualificationTab.patchValue(this.data);
      this.QualificationTab.controls['qualificationType'].patchValue(
        this.data.qualificationTypeId
      );

      if (this.data?.physicalAddress) {
        this.PhysicalAddressTab.patchValue(this.data?.physicalAddress);
        this.PhysicalAddressTab.controls['id'].patchValue(this.data.id);
      }
      if (this.data?.MailingAddressTab) {
        this.MailingAddressTab.patchValue(this.data?.mailingAddress);
        this.MailingAddressTab.controls['id'].patchValue(this.data.id);
      }

      var tnState = this.stateTypes.filter((x) => x.abbrv == 'TN');
      console.log(tnState);
      if (tnState.length > 0) {
        var tnStateId = tnState[0].id;
        if (!this.PhysicalAddressTab.controls['stateId'].value) {
          this.PhysicalAddressTab.controls['stateId'].patchValue(tnStateId);
        }
        if (!this.MailingAddressTab.controls['stateId'].value) {
          this.MailingAddressTab.controls['stateId'].patchValue(tnStateId);
        }
      }
      if (!this.isDynamicValidationAdded) {
        this.AddLicenseTabDynamicValidators();
        this.AddQualitficationTabDynamicValidators();
      }
      const licenseInfo = this.getLicenseData(this.data);
      this.LicenseTab.patchValue(licenseInfo);

      this.ConfirmationTab.patchValue(this.data);
      this.SignatureTab.patchValue(this.data);
      console.log('county ' + this.LicenseTab.controls['county'].value);
      this.filterCitiesforCounty(this.LicenseTab.controls['county'].value);
      this.setAuthorization();
      let rq = this.requestTypes.filter(
        (x) => x.id == this.data.exemptionRequestTypeId
      );
      if (rq.length > 0) this.requestTypeName = rq[0].description;

      this.validateAllFormFields(this.form);
      if (
        this.verificationTabApplies.includes(
          this.data?.exemptionRequestType?.code
        )
      ) {
        this.selectedTab = InternalTabTypes.VerificationTab;
      }
    });
  }

  displayOrHideTab(tabIndex: number, displayTab: boolean): void {
    const tabHeaders = document.querySelectorAll('.mat-tab-label');
    if (tabHeaders[tabIndex]) {
      (tabHeaders[tabIndex] as HTMLElement).style.display = displayTab ? 'inherit' : 'none';
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  setAuthorization() {
    if (
      this.editUserRoles.includes(this.user.role) &&
      this.canModifyExemtion()
    ) {
      this.canSave = true;
    }
    if (
      this.editUserRoles.includes(this.user.role) &&
      this.data.assignedToApplicationUser === null
    ) {
      this.canAssign = true;
    } else {
      this.canAssign = false;
    }
    console.log(this.canAssign);
    if (!this.canSave) {
      this.form.disable();
    }
  }

  getLicenseData(data: any): any {
    return {
      hasActiveStateLicense: this.data?.CspLicenseId == null ? true : false,
      stateLicenseNumber: data?.stateLicense?.licenseNumber,
      stateLicenseExpirationDate: data?.stateLicense?.licenseExpirationDate,
      county: data?.countyLicense?.countyId,
      countyLicenseNumber: data?.countyLicense?.licenseNumber,
      countyLicenseExpirationDate: data?.countyLicense?.licenseExpirationDate,
      city: data?.cityLicense?.cityId,
      cityLicenseNumber: data?.cityLicense?.licenseNumber,
      cityLicenseExpirationDate: data?.cityLicense?.licenseExpirationDate,
      requestStatusTypeId: data?.requestStatusTypeId,
      externalStatusTypeId: data?.externalStatusTypeId,
      id: data?.id,
    } as LicenseTab;
  }

  canModifyExemtion() {
    let canModify = true;
    if (this.requestStatusTypeId.value) {
      var codeItem = this.requestStatusTypes.filter(
        (x) => x.id == this.requestStatusTypeId.value
      );
      if (
        codeItem.length > 0 &&
        this.readOnlyRequstStatusTypeCode.includes(codeItem[0].code)
      )
        canModify = false;
    }
    return canModify;
  }

  onSave() {
    this.IsApproving(false);
  }

  IsApproving(canContinue: boolean) {
    const approvedStatusId = this.requestStatusTypes.find(x => x.code == this.approvedRequstStatusTypeCode)?.id;
    if (this.data.requestStatusTypeId != approvedStatusId && this.requestStatusTypeId.value == approvedStatusId) {
      let dialogRef = this.dialog.open(YesNoModalComponent, {
        data: {
          title: 'Approving',
          message: `You have changed the status to Approved. \n\n Do you wish to proceed?`,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((res) => {
        console.log(res);
        if (res.data == 'yes') {
          this.validateAndSave(canContinue);
        }
      });
    } else {
      this.validateAndSave(canContinue);
    }
  }

  onCancel() {
    let dialogRef = this.dialog.open(YesNoModalComponent, {
      data: {
        title: 'Cancel',
        message: `Are you sure you want to cancel your application?`,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      console.log(res);
      if (res.data == 'yes') {
        this.routerService.navigateByUrl('/home');
      }
    });
  }

  interceptTabChange(tab: MatTab, tabHeader: MatTabHeader, idx: number) {
    return false;
  }

  tabChanged(event: any) {
    console.log(event);
    this.selectedTab = event.tab?.textLabel;
    this.SetValidatorForSelectedTab();
  }
  SetValidatorForSelectedTab() {
    // throw new Error('Method not implemented.');
  }

  Continue() {
    this.setNextTabIndex();
  }

  saveAndContinue() {
    this.IsApproving(true);
  }

  validateAndSave(continueNextTab: Boolean) {
    console.log('validate and save' + continueNextTab);
    if (this.selectedTab == InternalTabTypes.VerificationTab) {
      if (continueNextTab) this.setNextTabIndex();
    }
    if (this.selectedTab == InternalTabTypes.QualificationTab) {
      if (!this.QualificationTab.valid) {
        this.toastr.warning('Please correct highlighted error.', 'Warning', {
          positionClass: 'toast-top-center',
          timeOut: 3000,
        });
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.PhysicalAddressTab) {
      if (!this.PhysicalAddressTab.valid) {
        this.toastr.warning('Please correct highlighted error.', 'Warning', {
          positionClass: 'toast-top-center',
          timeOut: 3000,
        });
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.LicenseTab) {
      if (!this.LicenseTab.valid) {
        this.toastr.warning('Please correct highlighted error.', 'Warning', {
          positionClass: 'toast-top-center',
          timeOut: 3000,
        });
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.PaymentTab) {
      if (!this.PaymentTab.valid) {
        this.toastr.warning('Please correct highlighted error.', 'Warning', {
          positionClass: 'toast-top-center',
          timeOut: 3000,
        });
        return;
      }
    }
    if (
      this.selectedTab == InternalTabTypes.SignatureTab &&
      this.SignatureTab.controls['signatureICertify'].value != true
    ) {
      let dialogRef = this.dialog.open(WarningModalComponent, {
        data: {
          title: 'Warning',
          message: `You have not indicated “I Certify” for the applicant. \n If this is correct, click OK to continue.\n Click Cancel to go back. `,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((res) => {
        console.log(res);
        if (res.data == 'ok') {
          this.saveTabsData(continueNextTab);
        }
      });
    } else {
      this.saveTabsData(continueNextTab);
    }
  }

  private saveTabsData(continueNextTab: Boolean) {
    const errorMsg = 'Error occured while saving data.';
    switch (this.selectedTab) {
      case InternalTabTypes.QualificationTab: {
        var tabdata = this.QualificationTab.value as QualificationTab;
        tabdata.requestStatusTypeId = this.requestStatusTypeId.value;
        tabdata.externalStatusTypeId = this.externalStatusTypeId.value;
        this.exemptionFilingRequestService
          .saveQualificationTab(tabdata)
          .subscribe(
            (res: any) => {
              this.refreshData();
              console.log(res);
              if (continueNextTab) this.setNextTabIndex();
            },
            (error) => {
              console.log(error);
              this.toastr.error(errorMsg + "\n" + error.error, 'Error', {
                positionClass: 'toast-top-center',
                timeOut: 3000,
              });
            }
          );
        break;
      }
      case InternalTabTypes.PhysicalAddressTab: {
        var phyTab = this.PhysicalAddressTab.value as PhysicalAddressTab;
        phyTab.requestStatusTypeId = this.requestStatusTypeId.value;
        phyTab.externalStatusTypeId = this.externalStatusTypeId.value;
        console.log(phyTab);
        this.exemptionFilingRequestService
          .savePhysicalAddressTab(phyTab)
          .subscribe(
            (res: any) => {
              this.refreshData();
              console.log(res);
              if (
                res.uspsValidationResponse &&
                res.uspsValidationResponse?.infoUsps?.addressUpdated
              ) {
                this.populateNewAddress(res.uspsValidationResponse?.infoUsps);
                let newAddress =
                  res.uspsValidationResponse?.infoUsps?.address1 + '\n';
                if (res.uspsValidationResponse?.infoUsps?.address2) {
                  newAddress +=
                    res.uspsValidationResponse?.infoUsps?.address2 + '\n';
                }
                newAddress += `${res.uspsValidationResponse?.infoUsps?.city} ${res.uspsValidationResponse?.infoUsps?.state} ${res.uspsValidationResponse?.infoUsps?.zipCode}`;
                // let dialogRef = this.dialog.open(ConfirmModalComponent, {
                //   data: {
                //     title: 'Address',
                //     message: `We have corrected the address based on the USPS database. \n\n ${newAddress}\n\n If this is correct, click on Save & Continue. Otherwise correct the address before continue. `,
                //   },
                //   disableClose: true,
                // });
                // dialogRef.afterClosed().subscribe((res) => {
                //   console.log(res);
                //   // if (res.data == 'ok') {
                //   //   if (continueNextTab) this.setNextTabIndex();
                //   // }
                // });
              } else {
                console.log("usps address check failed " + continueNextTab)
                if (continueNextTab) this.setNextTabIndex();
              }
            },
            (error) => {
              this.toastr.error(errorMsg, 'Error', {
                positionClass: 'toast-top-center',
                timeOut: 3000,
              });
            }
          );
        break;
      }
      case InternalTabTypes.MailingAddressTab: {
        var mailTab = this.MailingAddressTab.value as MailingAddressTab;
        mailTab.requestStatusTypeId = this.requestStatusTypeId.value;
        mailTab.externalStatusTypeId = this.externalStatusTypeId.value;
        this.exemptionFilingRequestService
          .saveMailingAddressTab(mailTab)
          .subscribe(
            (res: any) => {
              this.refreshData();
              console.log(res);
              if (continueNextTab) this.setNextTabIndex();
            },
            (error) => {
              this.toastr.error(errorMsg, 'Error', {
                positionClass: 'toast-top-center',
                timeOut: 3000,
              });
            }
          );
        break;
      }
      case InternalTabTypes.LicenseTab: {
        var licTab = this.LicenseTab.value as LicenseTab;
        licTab.requestStatusTypeId = this.requestStatusTypeId.value;
        licTab.externalStatusTypeId = this.externalStatusTypeId.value;
        this.exemptionFilingRequestService.saveLicenseTab(licTab).subscribe(
          (res: any) => {
            this.refreshData();
            console.log(res);
            if (continueNextTab) this.setNextTabIndex();
          },
          (error) => {
            this.toastr.error(errorMsg, 'Error', {
              positionClass: 'toast-top-center',
              timeOut: 3000,
            });
          }
        );
        break;
      }
      case InternalTabTypes.ConfirmationTab: {
        var confTab = this.ConfirmationTab.value as ConfirmationTab;
        confTab.requestStatusTypeId = this.requestStatusTypeId.value;
        confTab.externalStatusTypeId = this.externalStatusTypeId.value;
        this.exemptionFilingRequestService
          .saveConfirmationTab(confTab)
          .subscribe(
            (res: any) => {
              this.refreshData();
              console.log(res);
              if (continueNextTab) this.setNextTabIndex();
            },
            (error) => {
              this.toastr.error(errorMsg, 'Error', {
                positionClass: 'toast-top-center',
                timeOut: 3000,
              });
            }
          );
        break;
      }
      case InternalTabTypes.SignatureTab: {
        var sigTab = this.SignatureTab.value as SignatureTab;
        sigTab.requestStatusTypeId = this.requestStatusTypeId.value;
        sigTab.externalStatusTypeId = this.externalStatusTypeId.value;
        this.exemptionFilingRequestService.saveSignatureTab(sigTab).subscribe(
          (res: any) => {
            this.refreshData();
            console.log(res);
            if (continueNextTab) this.setNextTabIndex();
          },
          (error) => {
            this.toastr.error(errorMsg, 'Error', {
              positionClass: 'toast-top-center',
              timeOut: 3000,
            });
          }
        );
        break;
      }
      case InternalTabTypes.PaymentTab: {
        console.log(this.PaymentTab.value);
        var payTab = this.PaymentTab.value as PaymentTab;
        payTab.requestStatusTypeId = this.requestStatusTypeId.value;
        payTab.externalStatusTypeId = this.externalStatusTypeId.value;
        payTab.exemptionFilingRequestId = this.requestId;
        console.log(payTab);

        this.exemptionFilingRequestService.savePaymentTab(payTab).subscribe(
          (res: any) => {
            this.refreshData();
            console.log(res);
          },
          (error) => {
            this.toastr.error(errorMsg, 'Error', {
              positionClass: 'toast-top-center',
              timeOut: 3000,
            });
          }
        );
        break;
      }
    }
  }
  populateNewAddress(infoUsps: any) {
      this.PhysicalAddressTab.controls['address1'].patchValue(infoUsps?.address1);
      this.PhysicalAddressTab.controls['address2'].patchValue(infoUsps?.address2);
      this.PhysicalAddressTab.controls['city'].patchValue(infoUsps?.city);
      this.PhysicalAddressTab.controls['zipCode'].patchValue(infoUsps?.zipCode);
  }

  getEndPoint() {
    return '';
  }

  onAssigned() {
    this.exemptionFilingRequestService
      .assignUserExemptionFilingRequest(this.requestId)
      .subscribe((data) => {
        this.exemptionFilingRequestService
          .getNotes(this.requestId)
          .subscribe((res) => {
            this.loadData();
          });
      });
    // assignUserExemptionFilingRequest
  }

  navigateTo(link: any, id: any) {
    this.routerService.navigate([link, btoa(id)]);
  }

  private setNextTabIndex() {
    console.log(this.PysicalMailingSame.value);
    console.log(this.selectedTab);

    if (
      this.selectedTab == InternalTabTypes.PhysicalAddressTab &&
      this.PysicalMailingSame.value == true
    ) {
      this.selectedIndex += 2;
    } else this.selectedIndex += 1;
  }

  previousStep() {
    if (
      this.selectedTab == InternalTabTypes.LicenseTab &&
      this.PysicalMailingSame.value == true
    ) {
      this.selectedIndex -= 2;
    } else {
      this.selectedIndex -= 1;
    }
    console.log(this.selectedIndex);
  }

  private CreateForms() {
    this.QualificationTab = this.fb.group({
      id: [this.requestId],
      qualificationType: [''],
      entityControlNumber: [''],
      filingEntityName: [''],
      fein: [''],
      firstName: [''],
      middleName: [''],
      lastName: [''],
      nameSuffix: [''],
      birthDate: [''],
      lastFourSocialSecurityNumber: [
        '',
        [Validators.minLength(4), Validators.maxLength(4)],
      ],
      contactPhone: [''],
      contactPhoneExtension: ['', [Validators.maxLength(6)]],
      contactEmail: [''],
      requestStatusTypeId: this.requestStatusTypeId,
      externalStatusTypeId: this.externalStatusTypeId,
    }); ///^[0-9]{10,10}$/
    this.PysicalMailingSame = new FormControl('');
    this.PhysicalAddressTab = this.fb.group({
      id: [this.requestId],
      addressTypeId: [''],
      address1: [''],
      address2: [''],
      address3: [''],
      city: [''],
      stateId: [''],
      zipCode: [''],
      countyId: [''],
      validateAddress: [true],
      isMailUndeliverable: this.PysicalMailingSame,
      requestStatusTypeId: this.requestStatusTypeId,
      externalStatusTypeId: this.externalStatusTypeId,
    });
    this.MailingAddressTab = this.fb.group({
      id: [this.requestId],
      addressTypeId: [''],
      address1: [''],
      address2: [''],
      address3: [''],
      city: [''],
      stateId: [''],
      zipCode: [''],
      countyId: [''],
      validateAddress: [true],
      requestStatusTypeId: this.requestStatusTypeId,
      externalStatusTypeId: this.externalStatusTypeId,
    });
    this.LicenseTab = this.fb.group({
      id: [this.requestId],
      hasActiveStateLicense: [''],
      stateLicenseNumber: ['', Validators.pattern("\\d*")],
      stateLicenseExpirationDate: [''],
      cspLicense: [''],
      county: ['', Validators.required],
      countyLicenseNumber: [''],
      countyLicenseExpirationDate: [''],
      city: ['', Validators.required],
      cityLicenseNumber: [''],
      cityLicenseExpirationDate: [''],
      requestStatusTypeId: [this.requestStatusTypeId.value],
      externalStatusTypeId: this.externalStatusTypeId,
    });
    this.SignatureTab = this.fb.group({
      id: [this.requestId],
      signatureFirstName: [''],
      signatureMiddleName: [''],
      signatureLastName: [''],
      signatureTitle: [''],
      signatureICertify: [''],
      requestStatusTypeId: this.requestStatusTypeId,
      externalStatusTypeId: this.externalStatusTypeId,
    });
    this.ConfirmationTab = this.fb.group({
      id: [this.requestId],
      attestToTCA: [''],
      waveRightsToSue: [''],
      requestStatusTypeId: this.requestStatusTypeId,
      externalStatusTypeId: this.externalStatusTypeId,
    });
    this.PaymentTab = this.fb.group({
      id: [this.requestId],
      payrefund: [''],
      paymentTypeId: ['', [Validators.required]],
      checkNumber: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      fisAuthorizationNumber: [''],
      fisPaymentType: [''],
      fisBillingName: [''],
      fisBillingAddress: [''],
      fisBillingCity: [''],
      fisBillingState: [''],
      fisBillingZip: [''],
      fisBillingEmail: [''],
      fisBillingPhone: [''],
      fisTransactionId: [''],
      requestStatusTypeId: this.requestStatusTypeId,
      externalStatusTypeId: this.externalStatusTypeId,
    });
  }
}
